export default __webpack_public_path__ + "static/media/camperplaats.5dcd05da.svg";